// „Целият списък" → редовете на изписването, без дубликат (чисти функции).
// Търсачката прави ВИНАГИ нов ред (партидата е на реда), но изборът от
// списъка с въведено количество НЕ дублира: вписаният вече продукт (ред извън
// разделена рецепта) или рецепта получава количеството си, новият се добавя
// накрая. Продукт, който го има само в разделена рецепта, получава нов ред —
// групата на рецептата не се пипа.
import type { AddKind, WriteoffLineDraft, WriteoffSearchResult } from "./writeoffWorksheetShared";

// Изборът: какво и колко (текстът на клетката; null = не е въведено)
export type WriteoffCatalogPick = { result: WriteoffSearchResult; quantity: string | null };

// Редът, който изборът попълва вместо да прави нов
export const catalogTargetLineOf = (
  lines: WriteoffLineDraft[],
  kind: AddKind,
  id: number,
): WriteoffLineDraft | undefined =>
  lines.find((line) =>
    kind === "product"
      ? line.kind === "product" && line.productId === id && line.groupId == null
      : line.kind === "recipe" && line.recipeId === id,
  );

export type CatalogLinesPlan = {
  // ключ на вписан ред → новото количество
  fills: Map<number, string>;
  // изборите за нови редове (в реда на каталога)
  fresh: WriteoffCatalogPick[];
  // първият избор е вписан ред → ключът му (фокусът); иначе null — фокусът
  // отива в първия нов ред
  firstExistingKey: number | null;
};

export const planCatalogLines = (lines: WriteoffLineDraft[], picks: WriteoffCatalogPick[]): CatalogLinesPlan => {
  const fills = new Map<number, string>();
  const fresh: WriteoffCatalogPick[] = [];
  let firstExistingKey: number | null = null;
  for (const [index, pick] of picks.entries()) {
    const target = catalogTargetLineOf(lines, pick.result.kind, pick.result.id);
    if (!target) {
      fresh.push(pick);
      continue;
    }
    if (pick.quantity != null) fills.set(target.key, pick.quantity);
    if (index === 0) firstExistingKey = target.key;
  }
  return { fills, fresh, firstExistingKey };
};
